const config = {
    token: {
        colorPrimary: "#ee3b45"
    },
    components: {
        Button: {
            fontWeight: 600,
            defaultColor: "#000"
        },
        Menu: {
            itemHeight: 60,
            itemHoverBg: "rgba(255, 255, 255, 0.5)",
            itemColor: "#fff",
            itemMarginInline: 0,
            itemSelectedBg: "#fff",
            darkItemBg: "#efefef",
            darkItemColor: "#000",
            darkItemHoverColor: "#df7f7f"
        },
        InputNumber: {
            activeBorderColor: "#abc6f5",
            activeShadow: "0 0 0 2px rgba(5,145,255,0.1)",
            hoverBorderColor: "#abc6f5"
        },
        Input: {
            activeBorderColor: "#abc6f5",
            activeShadow: "0 0 0 2px rgba(5,145,255,0.1)",
            hoverBorderColor: "#abc6f5"
        },
        Select: {
            activeBorderColor: "#abc6f5",
            activeShadow: "0 0 0 2px rgba(5,145,255,0.1)",
            hoverBorderColor: "#abc6f5"
        },
        Slider: {
            handleLineWidth: 4,
            railSize: 8,
            trackBg: "#ee3b45",
            dotSize: 12,
            dotBorderColor: "#ee3b45",
            trackHoverBg: "#ee3b45"
        },
        Layout: {
            siderBg: "#efefef",
            triggerBg: "#b3b2b2"
        }
    }
};

export default config;
